<template>
  <div>
    <el-dialog
      custom-class="real-dialog"
      :title="title"
      :visible.sync="dialogVisible"
      width="400px"
      @close="handleClose"
      center
      append-to-body
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="选择出口名称" style="width: 100%">
          <gateSelect
            size="mini"
            ref="item"
            @change="getItem"
            :selectkey="'Id'"
            v-model="OutGateId"
            :isDisabled="false"
            :Direction="2"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import showdialog from "@/minxs/showdialog";
import gateSelect from "@/serviceComponents/gateSelect";

export default {
  components: {
    gateSelect
  },
  props: {
    title: {
      type: String,
      default: "",
    },
  },
  mixins: [showdialog],
  data() {
    return {
      form: {
        input: "",
      },
      OutGateId: "",
    };
  },
  watch: {
    GateId: function (newV) {
      this.OutGateId = newV;
      this.$nextTick(()=>{
        this.$refs.item.server(true);
      })
    },
  },
  mounted() {
    if (this.GateId) {
      this.OutGateId = this.GateId;
      this.$nextTick(()=>{
        this.$refs.item.server(true);
      })
    }
  },
  computed: {
    GateId: function () {
      let arr = this.$store.state.order.gateIds
        ? this.$store.state.order.gateIds
        : [];
      let leftArr = arr.filter((item) => {
        return Number(item.Direction) === 2;
      });
      let id = leftArr[0] ? leftArr[0].Id : undefined;
      return id;
    },
  },
  methods: {
    getItem(item) {
      this.OutGateId = item.Id;
    },
    handleClick() {
      // console.log(this.form);
      this.$emit("getOutGateId", this.OutGateId);
      this.$emit("update:showdialog", false);
    },
  },
};
</script>
